import type { OrderedSubMenuItem } from '@redturtle/qubicaamf-theme/components/Header/MegaMenu/MegaMenu';
import type { MenuItem } from '@redturtle/qubicaamf-theme/types/dropdown-menu';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

export function getItemsByPath(items, pathname) {
  let rootPathConfig = null;
  const itemsByPath = Array.isArray(items)
    ? items?.reduce((acc, val) => {
        if (val.rootPath === '/') {
          rootPathConfig = val;
          return acc;
        }
        return { ...acc, [val.rootPath]: val };
      }, {})
    : [];
  const matchingPaths = Object.keys(itemsByPath)
    .filter((path) => pathname === path || pathname.startsWith(`${path}/`))
    .sort((a, b) => {
      if (a.length > b.length) return -1;
      else if (a.length < b.length) return 1;
      else return 0;
    });

  if (matchingPaths.length > 0) return itemsByPath[matchingPaths[0]].items;
  else if (rootPathConfig) return rootPathConfig.items;
  else return [];
}

export function mergeData(arr1: MenuItem[], arr2: OrderedSubMenuItem[]) {
  const merged = arr1.reduce((acc, curr) => {
    const id = curr['@id'];
    const fromArr2 = arr2?.find((a2) => a2['@id'] === flattenToAppURL(id));
    return [...acc, { ...curr, ...fromArr2 }];
  }, [] as OrderedSubMenuItem[]);
  return merged;
}
